"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _svg = require("./../../../configuration/svg");

var _utils = require("./../../../configuration/utils");

var _constans = require("./../../../configuration/constans");

var _wdh = require("@demant/wdh");

var _utils2 = require("../../../configuration/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FavoriteIconComponent = function FavoriteIconComponent(_ref) {
  var product = _ref.product,
      dictionary = _ref.dictionary;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      productId = _useState2[0],
      setProductId = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      isFavorite = _useState4[0],
      setFavorite = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      favoriteProducts = _useState6[0],
      setFavoriteProducts = _useState6[1];

  (0, _react.useEffect)(function () {
    (0, _wdh.onEvent)('removeFromList', function (data) {
      setFavoriteProducts((0, _utils.sessionStorageFactory)('setItem', _constans.initialState.favoriteProductsName, data));
    });
    setFavoriteProducts((0, _utils.sessionStorageFactory)('checkStorageItem', _constans.initialState.favoriteProductsName) ? (0, _utils.sessionStorageFactory)('getItem', _constans.initialState.favoriteProductsName) : null);
  }, []);
  (0, _react.useEffect)(function () {
    if (product) {
      setProductId((0, _utils.getProductId)(product));
    }

    if (favoriteProducts) {
      setFavorite(favoriteProducts[productId]);
      (0, _utils.sessionStorageFactory)('setItem', 'favoriteListDictionary', dictionary);
    }

    if ((0, _utils.sessionStorageFactory)('checkLength', 'favoriteListDictionary')) {
      (0, _utils.sessionStorageFactory)('setItem', 'favoriteListDictionary', dictionary);
    }
  }, [product, setProductId, productId, favoriteProducts, setFavorite]);

  var handleClickFavorite = function handleClickFavorite(e, prod) {
    e.preventDefault();
    e.stopPropagation();
    var favoriteData = (0, _utils.sessionStorageFactory)('checkStorageItem', _constans.initialState.favoriteProductsName) ? (0, _utils.sessionStorageFactory)('getItem', _constans.initialState.favoriteProductsName) : {};

    if (isFavorite) {
      delete favoriteData[productId];
    } else {
      favoriteData[productId] = prod;
    }

    (0, _utils2.sendDataLayerEvent)('Add to favourite', "".concat(product.title + (product.style || product.subtitle), " ").concat(isFavorite ? 'deactivate' : 'activate'));
    setFavorite(!isFavorite);
    setFavoriteProducts((0, _utils.sessionStorageFactory)('setItem', _constans.initialState.favoriteProductsName, favoriteData));
    (0, _wdh.triggerEvent)('changeStorage', favoriteData);

    try {
      window.headerFavoriteFeatureImporter();
    } catch (e) {
      console.log('error during favorite feature import');
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, productId && /*#__PURE__*/_react["default"].createElement("div", {
    className: isFavorite ? "favorite-icon active" : "favorite-icon",
    tabIndex: 5,
    "aria-label": !isFavorite ? 'add to favorite' : 'remove from favorite',
    role: "button",
    dangerouslySetInnerHTML: {
      __html: _svg.hearthSVG
    },
    onClick: function onClick(e) {
      return handleClickFavorite(e, product);
    }
  }));
};

var _default = FavoriteIconComponent;
exports["default"] = _default;